import type { Tenant, TenantAiSettings, TenantSecuritySettings } from '@detect/shared';
import { api, withTenant } from './api';
import type { WithId } from './types';

/** The current tenant's own record (GET/PATCH /tenants/current). */
export const tenantService = {
  current: (tenantId: string): Promise<WithId<Tenant>> =>
    api.get<WithId<Tenant>>(withTenant('/tenants/current', tenantId)),
  /** Replaces the whole sign-in policy (account_admin only; enforced server-side). */
  updateSecurity: (tenantId: string, security: TenantSecuritySettings): Promise<WithId<Tenant>> =>
    api.patch<WithId<Tenant>>(withTenant('/tenants/current', tenantId), { security }),
  /** Replaces the whole AI settings (account_admin only; enforced server-side). Everything is off until switched on. */
  updateAi: (tenantId: string, ai: TenantAiSettings): Promise<WithId<Tenant>> =>
    api.patch<WithId<Tenant>>(withTenant('/tenants/current', tenantId), { ai }),
};
